import React, { createContext, useEffect, useState } from "react";

import { MapMarker, Store } from "@/custom-types/StoreLocator";

export type StoreLocatorContextProps = {
  selectedStore?: Store;
  selectedMarker?: MapMarker;
  hoveredStore?: number;
  setSelectedStore: (store?: Store) => void;
  setSelectedMarker: (marker?: MapMarker) => void;
  setHoveredStore: (storeId?: number) => void;
  clearHoveredStore: () => void;
  setFiltersOpen: (open: boolean) => void;
  filtersOpen: boolean;
};
const StoreLocatorContext = createContext<StoreLocatorContextProps>({
  clearHoveredStore: () => {},
  filtersOpen: false,
  setFiltersOpen: () => {},
  setHoveredStore: () => {},
  setSelectedMarker: () => {},
  setSelectedStore: () => {},
});

type StoreLocatorProviderProps = {
  children: React.ReactNode;
};

export const StoreLocatorProvider = ({
  children,
}: StoreLocatorProviderProps) => {
  const [selectedStore, setSelectedStore] = useState<Store>();
  const [selectedMarker, setSelectedMarker] = useState<MapMarker>();
  const [hoveredStore, setHoveredStore] = useState<number>();
  const [filtersOpen, setFiltersOpen] = useState<boolean>(false);
  const clearHoveredStore = () => setHoveredStore(undefined);

  useEffect(() => {
    if (!selectedStore) {
      return;
    }
    document
      .getElementById(`store-card-${selectedStore?.id}`)
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [selectedStore]);

  return (
    <StoreLocatorContext.Provider
      value={{
        clearHoveredStore,
        hoveredStore,
        ...(selectedStore && { selectedStore }),
        ...(selectedMarker && { selectedMarker }),
        filtersOpen,
        setFiltersOpen,
        setHoveredStore,
        setSelectedMarker,
        setSelectedStore,
      }}
    >
      {children}
    </StoreLocatorContext.Provider>
  );
};

export default StoreLocatorContext;
